import styled from "styled-components";
import { device } from "components/styles";

export const Lnb = styled.div`
  color: ${(props) => props.theme.colors.black};
  width: 320px;
  z-index: 100;
  height: calc(100vh - 6.2rem);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
  position: sticky;
  top: 6.2rem;
  left: 0;
  > div {
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    padding: 3.2rem 2.4rem;
    gap: 3rem;
    display: flex;
    flex-direction: column;
  }

  h2 {
    font-size: 2.4rem;
    line-height: 3.6rem;
    span {
      color: ${(props) => props.theme.colors.gray[700]};
      font-size: 1.5rem;
      font-weight: 500;
    }
  }
  h3 {
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 500;
  }
  button {
    margin-bottom: 1rem;
  }
  a {
    text-decoration: none;
    font-size: 1.4rem;
    display: block;
    text-align: center;
    color: ${(props) => props.theme.colors.gray[900]};
  }

  .myInfo {
    text-align: center;
    img {
      width: 80px;
      height: 80px;
      border: 1px solid #eee;
      border-radius: 50%;
    }

    ul {
      display: flex;
      justify-content: space-between;
      margin: 20px 0;
      li {
        width: calc((100% - 40px) / 3);
        flex-shrink: 0;
        flex-grow: 1;
        list-style: none;
        text-align: center;
        border-right: 1px solid #f2f4f7;
        &:last-child {
          border: none;
        }
        svg {
          display: block;
          margin: 0 auto;
        }
        span {
          display: block;
          margin: 5px auto;
          font-size: 1.3rem;
          color: ${(props) => props.theme.colors.gray[700]};
        }
        p {
          font-size: 1.5rem;
          color: ${(props) => props.theme.colors.gray[900]};
          font-weight: 700;
        }
      }
    }

    .buttonWrap {
      display: flex;
      gap: 10px;
      > * {
        margin-bottom: 0;
      }
    }
  }
  .ranking {
    > div {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
      background-color: #f7faff;
      .cityRank span {
        display: inline-block;
        margin-left: 5px;
      }
      .line {
        width: 100%;
        height: 1px;
        background-color: #1d68f9;
      }
    }
  }

  .bookmark {
    .title {
      display: flex;
      justify-content: space-between;
      font-size: 1.6rem;
      align-items: center;
      margin-bottom: 2rem;
      p {
        svg {
          vertical-align: bottom;
        }
      }
    }
    span {
      font-size: 1.3rem;
      color: ${(props) => props.theme.colors.gray[700]};
      vertical-align: bottom;

      svg {
        vertical-align: middle;
      }
    }
    .nodata {
      font-size: 1.2rem;
      text-align: center;
      margin: 40px 0;
    }
    ul {
      li {
        cursor: pointer;
        font-size: 1.5rem;
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        gap: 5px;
        p {
          white-space: nowrap;
          display: flex;
          flex-grow: 1;
          gap: 2px;
          max-width: calc(100% - 60px);
          span {
            display: inline-block;
          }
          .cityName {
            flex-shrink: 0;
            overflow: hidden;
            max-width: 92px;
            font-size: 1.3rem;
            color: ${(props) => props.theme.colors.gray[700]};
            vertical-align: bottom;
            svg {
              vertical-align: middle;
            }
          }
          .hospitalName {
            color: ${(props) => props.theme.colors.gray[900]};
            font-size: 1.5rem;
            overflow: hidden;
            text-overflow: ellipsis;
            // max-width: calc(100% - 90px);
          }
          svg {
            vertical-align: bottom;
          }
        }

        > div {
          flex-shrink: 0;
          font-weight: 800;
          span {
            display: inline-block;
            min-width: 3.2rem;
            border-radius: 4px;
            margin-left: 1rem;
            color: inherit;
            text-align: center;
            svg {
              margin-right: 5px;
              margin-bottom: 3px;
            }
          }

          &.increase {
            color: #f23243;
            span {
              background-color: #fbf2f2;
              line-height: 1.6rem;
            }
          }
          &.decrease {
            color: #165ef3;
            span {
              background-color: #f1f8fd;
            }
          }
        }
      }
    }
  }
  > div {
    overflow: auto; /* 스크롤 가능 */
    -ms-overflow-style: none; /* IE, Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }

  @media all and (${device.mobile}) {
    display: none;
  }
`;
